import React from "react";

const RefundPolicy = () => {
  return (
    <div className="container-fluid py-5" style={{ marginTop: "110px" }}>
      <div className="row justify-content-center">
        <div className="col-lg-10">
          <div
            className="card border-0 rounded-4 p-4 p-md-5"
            style={{ fontSize: "16px", lineHeight: "1.8" }}
          >
            {/* Title */}
            <h1
              className="text-center mb-4 fw-bold"
              style={{ color: "#cc9051" }}
            >
              Refund Policy
            </h1>

            {/* Section 1 */}
            <h4 className="fw-bold mt-4">All Sales Are Final</h4>
            <p>
              We do not offer refunds, exchanges, or cancellations. Please make
              sure to carefully review your order before making a payment.
            </p>

            {/* Section 2 */}
            <h4 className="fw-bold mt-4">Payment Terms</h4>
            <p>
              We accept online payments through credit cards, PayPal, and other
              available methods. Please note,{" "}
              <strong>Cash on Delivery (COD)</strong> is not available.
            </p>

            {/* Section 3 */}
            <h4 className="fw-bold mt-4">Why No Refunds or Exchanges?</h4>
            <p>
              We are a small, independent art business. Each artwork is crafted
              with care and often produced in limited quantities. Due to the
              unique and delicate nature of our products, we cannot accept
              returns or offer exchanges.
            </p>
            <p className="mb-3">
              However, we assure you that the quality of our products is not
              compromised, and we strive to deliver exactly what we promise.
            </p>

            {/* Section 4 */}
            <h4 className="fw-bold mt-4">What if I Receive a Damaged Product?</h4>
            <p>
              Although we take great care in packaging and shipping, damages may
              occur in rare cases. If your product arrives damaged:
            </p>
            <ul className="list-group list-group-flush mb-3">
              <li className="list-group-item">Contact us within 3 days of delivery.</li>
              <li className="list-group-item">
                Provide clear photos of the damaged item and the package.
              </li>
              <li className="list-group-item">
                Our team will assist you with resolving the issue promptly.
              </li>
            </ul>

            {/* Contact Section */}
            <h4 className="fw-bold mt-4">Need Help?</h4>
            <p>
              If you have any questions about this Refund Policy, reach out to
              us:
            </p>

            <p className="mb-1">
              📧 Email:
              <a href="mailto:tulikartsworks@gmail.com" className="ms-1">
                tulikartsworks@gmail.com
              </a>
            </p>

            <p>
              📞 Phone:
              <a href="tel:+91986926077" className="ms-1">
                +91 9869261077
              </a>
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default RefundPolicy;
